import { render } from "./NextCompetitionsscreen.vue?vue&type=template&id=721fef24&scoped=true"
import script from "./NextCompetitionsscreen.vue?vue&type=script&lang=js"
export * from "./NextCompetitionsscreen.vue?vue&type=script&lang=js"

import "./NextCompetitionsscreen.vue?vue&type=style&index=0&id=721fef24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721fef24"]])

export default __exports__